import { render, staticRenderFns } from "./taxation.vue?vue&type=template&id=ea63b8de&scoped=true&"
import script from "./taxation.vue?vue&type=script&lang=js&"
export * from "./taxation.vue?vue&type=script&lang=js&"
import style0 from "./taxation.vue?vue&type=style&index=0&id=ea63b8de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea63b8de",
  null
  
)

export default component.exports